export default {
  notifications: [],
  processing: false,
  error: null,
  success: null,
}



